// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import "babel-polyfill";
import Vue from "vue";
import App from "./App";
import "element-ui/lib/theme-chalk/index.css";
import Icon from "vue-svg-icon/Icon.vue";
//import '../theme/index.css'
Vue.component("icon", Icon);
import router from "./router";
import "./extentTable";

import ELEMENT from "element-ui";
import "./extentToolTip";

import Global from "./components/common/Global.vue";
import RequestUtil from "./util/RequestUtil.vue";
import store from "@/store/index";
import CommonUtils from "./util/CommonUtils.js";
import ElCommonUtils from "./util/ElCommonUtils.js";
import echarts from "echarts";
import dataV from "@jiaminghi/data-view";
import VueParticles from "vue-particles";
import { getUrlParam } from "./util/GetUrlParam";
let { Message } = ELEMENT;
// import htmlToPdf from './util/htmlToPdf'
// Vue.use(htmlToPdf)
Vue.use(VueParticles);
Vue.use(dataV);
//引入粘贴板
import clipboard from "clipboard";
Vue.prototype.clipboard = clipboard;

Vue.config.productionTip = false;
Vue.use(ELEMENT, { size: "small" });
// Vue.use(ElTable)
// Vue.use(ElTableColumn)
Vue.prototype.$Global = Global;
Vue.prototype.$RequestUtil = RequestUtil;
Vue.prototype.$Echarts = echarts;
Vue.prototype.$commonUtil = ElCommonUtils;

//全局添加过滤Emoji表情符方法
Vue.prototype.validForbid = function(value, number = 255) {
  value = value
    .replace(
      /[\uD83C|\uD83D|\uD83E][\uDC00-\uDFFF][\u200D|\uFE0F]|[\uD83C|\uD83D|\uD83E][\uDC00-\uDFFF]|[0-9|*|#]\uFE0F\u20E3|[0-9|#]\u20E3|[\u203C-\u3299]\uFE0F\u200D|[\u203C-\u3299]\uFE0F|[\u2122-\u2B55]|\u303D|[\A9|\AE]\u3030|\uA9|\uAE|\u3030/gi,
      ""
    )
    .replace(/\s/g, "");
  if (value.length >= number) {
    this.$message({
      type: "warning",
      message: `输入内容不能超过${number}个字符`
    });
  }
  return value;
};

//注册全局事件对象
window.eventBus = new Vue();
//注册全局公用方法
window.commonUtils = CommonUtils;
if (window.location.href.includes("localhost")) {
  //本地测试添加打印其他环境隐藏打印
  window.log = console.log.bind(console);
} else {
  window.log = () => {};
}
console.log("%c 欢迎使用杭州物源科技iMaster智能制造平台", "font-size:88px;color:green;font-weight:800");

/**
 * 当当前页面在浏览器中状态为visible；
 * 并且侧边栏显示隐藏状态改变重新加载当前页面
 */
document.addEventListener("visibilitychange", ev => {
  if (document.visibilityState == "visible") {
    window.addEventListener("storage", ev => {
      if (ev.key == "isYinXin") {
        window.location.reload();
      }
    });
  }
});

router.beforeEach(async (to, from, next) => {
  const defaultUrl = localStorage.getItem("defaultUrl");
  if (to.name == "webAppBoard") {
    next();
    return;
  }
  if (to.path == "/") {
    next({ path: defaultUrl });
    return;
  }
  let permission = null;
  if (localStorage.getItem("permission")) {
    if (localStorage.getItem("permission").startsWith("{") && localStorage.getItem("permission").endsWith("}")) {
      permission = JSON.parse(localStorage.getItem("permission") || {});
    } else {
      localStorage.setItem("permission", "{}");
      permission = {};
    }
  }
  if (to.fullPath.indexOf("yixin") != -1) {
    let pageTo = getUrlParam("page");
    let token = getUrlParam("token");
    localStorage.getItem("isYinXin", true);
    localStorage.setItem("isYiXin", true);
    localStorage.setItem("token", token);
    RequestUtil.get({
      url: "/api/extra/getPermissionsByToken",
      type: "sync",
      params: {
        token: token
      },
      success: res => {
        if (res.code == 0) {
          let token = res.token;
          let username = res.username;
          let btnPermission = res.btnPermission;
          localStorage.setItem("token", token);
          localStorage.setItem("username", username);
          localStorage.setItem("permission", JSON.stringify(btnPermission));
          localStorage.setItem("isSuperUser", res.isDefaultRole);
          if (pageTo != "/") {
            router.push({ path: "/" + pageTo });
          } else {
            router.go(0);
          }
          window.location.reload();
        } else {
          Message({
            type: "error",
            message: res.message
          });
        }
      }
    });
  }
  if (to.query.type == "yixin") {
    localStorage.setItem("isYiXin", true);
    localStorage.setItem("token", to.query.token);
  }

  if (to.query.openapiToken) {
    next();
    log(to.query, 888);
    return;
  }

  if (to.meta.permission && permission) {
    //设备汇总报表权限需要单独处理   只有当设备汇总 设备保养 设备工单都无权限时才阻止跳转
    if (to.path == "/Report/DevicecareReport") {
      if (!permission.btn_report_listWorkOrder && !permission.btn_report_listDevice && !permission.btn_report_deviceSummary) {
        Message.error("抱歉，您暂无权限访问该页面");
        return;
      }
      //工单管理 只有设备工单和工具工单都无权限时 阻止跳转
    } else if (to.path == "/DeviceCare/BaseCareOrder") {
      if (!permission.btn_workOrder_list && !permission.btn_tool_workOrderList) {
        Message.error("抱歉，您暂无权限访问该页面");
        return;
      }
      // 编码管理 勾选编码管理时 阻止跳转
    } else if (to.path == "/MasterData/CodeMgt") {
      if (!permission.btn_encode_page) {
        Message.error("抱歉，您暂无权限访问该页面");
        return;
      }
    } else {
      if (!permission[to.meta.permission]) {
        log(to.meta.permission, permission[to.meta.permission]);
        Message.error("抱歉，您暂无权限访问该页面");
        return;
      }
    }
  }
  if (to.path.includes("/openBoard")) {
    let oauthToken = localStorage.getItem("oauthToken");
    let loadUrl = `${to.query.openUrl}&oauthToken=${oauthToken}`;
    window.open(loadUrl, "_blank");
  }
  if (to.name == null) {
    next({ path: defaultUrl });
  }
  if (localStorage.getItem("token") != null) {
    // 通过vuex state获取当前的token是否存在
    //验证token是否过期判
    let expires = localStorage.getItem("expires_time");
    let now = new Date().getTime();
    if (!expires || now > expires) {
      //当过期时间小于当前时间或者过期时间不存在验证token是否过期
      RequestUtil.get({
        url: "/api/auth/checkToken",
        type: "sync",
        params: {
          token: localStorage.getItem("token")
        },
        success: res => {
          if (res.code == 0) {
            if (res.data == 0) {
              //token过期
              Message.error("当前登录已过期");
              localStorage.removeItem("token");
              localStorage.removeItem("username");
              localStorage.removeItem("permission");
              if (to.path == "/login") {
                next();
              } else {
                next({ path: "/login" });
              }
            }
            let expires_time = now + 16 * 60 * 60 * 1000;
            localStorage.setItem("expires_time", expires_time);
          }
        }
      });
    }
    if (to.path == "/login") {
      next({ path: defaultUrl });
    } else {
      if (to.query.iframeUrl) {
        to.meta.title = to.query.title;
      }
      next();
    }
  } else {
    if (to.path == "/login") {
      next();
    } else {
      if (to.path == "/WorkShopBoard") {
        next();
      } else {
        next({ path: "/login" });
      }
    }
  }
});

/* eslint-disable no-new */
new Vue({
  el: "#app",
  router,
  store,
  components: { App },
  template: "<App/>"
});



// WEBPACK FOOTER //
// ./src/main.js